import React from 'react';
import { Button, Chip, Popover, Typography } from '@mui/material';
import moment from 'moment';
import classes from '../docFwb.module.css';

const formatDate = (d) => (d && moment(d).isValid() ? moment(d).format('DDMMMYY HH:mm:ss').toUpperCase() : d || '');

const FwbVersionPopover = ({
  open = false,
  anchorEl = null,
  onClose,
  versions = [],
  selectedVersion = 1,
  onSelectVersion,
}) => {
  const versionList = Array.isArray(versions) && versions.length > 0
    ? [...versions].reverse()
    : [{
      version: 1,
      name: 'Version 1',
    }];

  return (
    <Popover
      open={Boolean(open && anchorEl)}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <div className={classes.versionPopover}>
        <div className={classes.versionPopoverHeader}>
          <Typography variant='subtitle2' className={classes.versionPopoverHeaderTitle}>
            FWB versions
          </Typography>
          <Typography variant='caption' className={classes.versionPopoverCount}>
            {versionList.length} {versionList.length === 1 ? 'version' : 'versions'}
          </Typography>
        </div>
        <div className={classes.versionPopoverList}>
          {versionList.map((ver, index) => {
            const isSelected = ver.version === selectedVersion;
            const dateStr = formatDate(ver.updated_at || ver.created_at);
            const dateLabel = ver.updated_at ? 'Updated' : 'Created';
            const versionName = ver.name || `Version ${ver.version}`;

            return (
              <div
                key={ver.version || index}
                className={classes.versionPopoverItem}
              >
                <div className={classes.versionPopoverItemHeader}>
                  <div className={classes.versionPopoverMetadata}>
                    <Typography
                      variant='body2'
                      noWrap
                      className={`${classes.versionPopoverTitle} ${isSelected ? classes.versionPopoverTitleCurrent : ''}`}
                    >
                      {versionName}
                    </Typography>
                    {dateStr && (
                      <Typography variant='caption' className={classes.versionPopoverDate}>
                        {dateLabel} {dateStr}
                      </Typography>
                    )}
                  </div>
                  {isSelected && (
                    <Chip
                      label='Current'
                      size='small'
                      className={classes.versionPopoverCurrentChip}
                    />
                  )}
                </div>
                <Button
                  size='small'
                  variant={isSelected ? 'contained' : 'outlined'}
                  fullWidth
                  aria-label={`Preview FWB ${versionName}`}
                  onClick={() => {
                    if (onSelectVersion) onSelectVersion(ver);
                    if (onClose) onClose();
                  }}
                  className={`${classes.versionPopoverButton} ${isSelected ? classes.versionPopoverButtonCurrent : ''}`}
                >
                  Preview
                </Button>
              </div>
            );
          })}
        </div>
      </div>
    </Popover>
  );
};

export default FwbVersionPopover;
